import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'store/hooks';
import { useLock } from 'features/room/useLock';
import { selectToolbarLockIconEnabled } from 'features/toolbar/toolbarSlice';
import { selectIsBreakoutRoom } from 'features/breakout-rooms/breakoutRoomsSlice';

export const useLockControl = () => {
  const { t } = useTranslation('room');

  const { roomLocked, canControlRoomEntry, triggerLockConfirmation } = useLock();

  const lockIconEnabled = useAppSelector(selectToolbarLockIconEnabled);
  const inBreakout = useAppSelector(selectIsBreakoutRoom);

  const isFeatureAvailable = lockIconEnabled && !inBreakout && canControlRoomEntry;

  return {
    triggerLockConfirmation,
    icon: roomLocked ? 'lock' : 'unlock',
    label: roomLocked ? t('toolbar.unlock_room') : t('toolbar.lock_room'),
    isFeatureAvailable,
  };
};
